import { createSlice } from "@reduxjs/toolkit";
import { SideBarType } from "../../Type/Redux";

const initialState: SideBarType = {
  toogleSidebar: false,
  scroll: false,
};

const LayoutSlice = createSlice({
  name: "SideBarSlice",
  initialState,
  reducers: {
    setToggleSidebar: (state) => {
      state.toogleSidebar = !state.toogleSidebar;
    },
    setScrollMenu: (state, action) => {
      state.scroll = action.payload;
    },
  },
});

export const { setToggleSidebar, setScrollMenu } = LayoutSlice.actions;

export default LayoutSlice.reducer;
